document.addEventListener('DOMContentLoaded', function () {
  const selectors = {
    comingSoonWrapper: '[data-coming-soon]',
    releaseDate: '[data-launch-date]',
    daySpan: '[data-days]',
    hourSpan: '[data-hours]',
    minuteSpan: '[data-minutes]',
    secondSpan: '[data-seconds]',
  };

  const applyLeadingZeroes = function (number) {
    let numberString = number.toString(10);

    if (numberString.length == 1) {
      numberString = '0' + numberString;
    }

    return numberString;
  };

  const getRemainingTime = function (endDate) {
    const total = Date.parse(endDate) - Date.parse(new Date());
    var seconds = applyLeadingZeroes(Math.floor((total / 1000) % 60));
    var minutes = applyLeadingZeroes(Math.floor((total / 1000 / 60) % 60));
    var hours = applyLeadingZeroes(Math.floor((total / (1000 * 60 * 60)) % 24));
    var days = applyLeadingZeroes(Math.floor(total / (1000 * 60 * 60 * 24)));

    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds,
    };
  };

  const initializeCountdown = function (section) {
    const timer = section.querySelector(selectors.releaseDate);
    const daySpan = timer.querySelector(selectors.daySpan);
    const hourSpan = timer.querySelector(selectors.hourSpan);
    const minuteSpan = timer.querySelector(selectors.minuteSpan);
    const secondSpan = timer.querySelector(selectors.secondSpan);
    const launchDate = timer.getAttribute('data-launch-date');

    const interval = setInterval(function () {
      const remainingTime = getRemainingTime(launchDate);

      daySpan.innerHTML = remainingTime.days;
      hourSpan.innerHTML = remainingTime.hours;
      minuteSpan.innerHTML = remainingTime.minutes;
      secondSpan.innerHTML = remainingTime.seconds;

      if (remainingTime <= 0) {
        clearInterval(inverval);
      }
    }, 1000);
  };

  const comingSoonWrappers = document.querySelectorAll(selectors.comingSoonWrapper);

  for (let i = 0; i < comingSoonWrappers.length; i++) {
    initializeCountdown(comingSoonWrappers[i]);
  }
});
